<script>
import CandidateImage from '@/components/candidate/candidate-image.vue'
import NoEducator from './no-educator.vue'

export default {
  name: 'DayByDayEducator',
  components: {
    CandidateImage,
    NoEducator,
  },
  props: {
    candidate: { type: Object, default: null },
    isMobile: { type: Boolean, default: false },
    classificationName: { type: String, default: '' },
  },
  emits: ['viewCandidate'],
  computed: {
    candidateFullName() {
      if (!this.candidate) return ''
      return `${this.candidate.firstName || ''} ${
        this.candidate.lastName || ''
      }`.trim()
    },
  },
}
</script>

<template>
  <!-- Day-by-day single candidate or 'no educator' for (Desktop & Mobile) -->
  <div class="d-flex align-center">
    <template v-if="candidate">
      <CandidateImage
        :id="candidate.id"
        :first-name="candidate.firstName"
        :last-name="candidate.lastName"
        size="32"
        :font-size="14"
        @click="$emit('viewCandidate', candidate)"
      />
      <div v-if="isMobile" class="d-flex flex-column text-start">
        <span class="educator-name" @click="$emit('viewCandidate', candidate)">
          {{ candidateFullName }}
        </span>
        <span class="ml-2"> {{ classificationName }}</span>
      </div>
      <span
        v-else
        class="educator-name"
        @click="$emit('viewCandidate', candidate)"
      >
        {{ candidateFullName }}
      </span>
    </template>
    <template v-else>
      <NoEducator
        v-if="isMobile"
        :is-mobile="isMobile"
        :classification-name="classificationName"
      />
      <NoEducator v-else />
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';

.candidateImage {
  margin-right: 0 !important;
}

.educator-avatar {
  position: relative;
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  transition: transform 0.12s ease;
}

.educator-avatar + .educator-avatar {
  margin-left: -30px;
}

.educator-avatar:hover {
  z-index: 5;
  transform: translateY(-1px);
}

.educator-name {
  max-width: 250px;
  padding-left: 8px;
  overflow: hidden;
  font-weight: 500;
  line-height: normal;
  color: $color-gray-600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
